// https://github.com/gtm-support/vue-gtm
import VueGtm from '@gtm-support/vue-gtm';
// to call this instance inside vue component use this.$gtm

// eslint-disable-next-line no-unused-vars
export const initGtm = (app, config) => {
  app.use(VueGtm, config);
};
